import Vue from "vue";
import * as path from "path";

import SETTINGS from "../settings.js";

import ServiceFactory from "@/services/service.factory";

export default class FileUsecase {
  constructor () {
    this.$notify = Vue.prototype.$notify;
  }

  /**
   * [notifyError description]
   * @param   {[type]}  message  [message description]
   * @return  {[type]}           [return description]
   */
  notifyError (message = "`不明なエラーが発生しました。") {
    if (!this.$notify) {
      alert(message);

      return;
    }

    this.$notify.error({
      title: "エラー",
      message,
    });
  }

  /**
   * [fetchMaximumFileSize description]
   * @param   {[type]}  size     [size description]
   * @return  {[type]}           [MByte 単位で返します]
   */
  fetchMaximumFileSize (size = "default") {
    const {
      MAXIMUM_FILE_SIZES,
      MB,
    } = SETTINGS;

    if (
      typeof size === "number" &&
      size > 0
    ) {
      return Math.round(Math.min(MAXIMUM_FILE_SIZES.max, size * MB) / MB);
    } else if (typeof size === "string") {
      return Math.round((MAXIMUM_FILE_SIZES[size] || MAXIMUM_FILE_SIZES.default) / MB);
    } else {
      return Math.round(MAXIMUM_FILE_SIZES.default / MB);
    }
  }

  /**
   * [validateFileSize description]
   * @param   {[type]}  file     [file description]
   * @param   {[type]}  size     [size description]
   * @return  {[type]}           [return description]
   */
  validateFileSize (file, size = "default") {
    const { MB } = SETTINGS;

    // 返ってくる値は MB 単位での数値です
    const maximumFileSize = this.fetchMaximumFileSize(size);

    if (file.size > maximumFileSize * MB) {
      this.notifyError(`ファイルサイズが大きすぎます。${maximumFileSize}MB以下のファイルを選択してください`);

      return false;
    }

    return true;
  }

  /**
   * [fetchFileName description]
   * 生成される値は以下の通り
   * fileName = {CATEGORY_DIR}/{TIMESTAMP}_{FILE_NAME}.{FILE_TYPE}
   * e.g. 'adminMessage/1724145121773_tabletLayout.png'
   * [メモ] 実質パス付きだが Storage での変数の扱いが file.name だったため fileName として扱う
   * @param   {[type]}  filepath  [filepath description]
   * @param   {[type]}  category  [category description]
   * @return  {[type]}            [return description]
   */
  fetchFileName (filepath, category, isEncode = false) {
    // ディレクトリ名を作成
    let dirPath = "";

    // ディレクトリ分け。家紋・梵字ならディレクトリを作成する。
    if (
      category !== undefined ||
      category !== null ||
      category !== ""
    ) {
      dirPath = category + "/" + filepath;
    } else {
      // 指定がない場合場合は何もつけない
      dirPath = filepath;
    }

    let dir = path.dirname(dirPath);

    if (dir === ".") {
      // filepath がファイル名のみで構成されている場合、カレントディレクトリが入るのでこれを無視する
      dir = "";
    }

    // ２バイト文字のファイル名が送られる場合もあるのでエンコードを行う
    const basename = isEncode ? encodeURI(path.basename(filepath)) : path.basename(filepath);

    // ファイルの上書きを防ぐため、ファイル名にタイムスタンプを付与する
    const timestamp = new Date().getTime();
    const basenameWithTimestamp = `${timestamp}_${basename}`;
    const fileName = path.join(dir, basenameWithTimestamp);

    return fileName;
  }

  /**
   * [uploadFile description]
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  file      [file description]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [return description]
   */
  async uploadFile (fileName, file, option = {}) {
    try {
      const result = await fileService.put(fileName, file, option);

      return Promise.resolve(result);
    } catch (err) {
      this.notifyError("ファイルのアップロードに失敗しました。もう一度やり直してください。");

      return Promise.reject(err);
    }
  }

  /**
   * [removeFile description]
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [return description]
   */
  async removeFile (fileName, option = {}) {
    try {
      const result = await fileService.remove(fileName, option);

      return Promise.resolve(result);
    } catch (err) {
      this.notifyError("ファイルの削除に失敗しました。");

      return Promise.reject(err);
    }
  }

  /**
   * [fetchURL description]
   * @param   {[type]}  key  [S3 Object key]
   * @return  {[type]}       [return description]
   */
  fetchURL (key) {
    return fileService.get(key);
  }

  /**
   * [getFileProperties description]
   * @param   {[type]}  files  [files description]
   * @return  {[type]}         [return description]
   */
  async getFileProperties (files) {
    const fileNameList = [];
    const blankOrDirectList = [];
    const fileURLList = [];

    const fileProperties = {
      fileName: fileNameList,
      blankOrDirect: blankOrDirectList,
      fileUrl: fileURLList,
    };

    if (
      !files ||
      !files.length
    ) {
      return fileProperties;
    }

    for (var i = 0; i < files.length; i++) {
      // ファイル名をユニークとするタイムスタンプ（13桁の数字）と_(アンダースコア)、計14桁を取り除く
      // e.g. 'adminMessage/1724145121773_tabletLayout.png' => "tabletLayout.png"
      const fileName = await files[i]
        .split("/")
        .pop()
        .slice(14);

      // ファイル名の追加する
      fileNameList.push(fileName);

      // ファイルの Presigned URL を取得して追加する
      // @see { https://qiita.com/tmiki/items/87697d3d3d5330c6fc08 | Presigned URL }
      const fileUrl = await fileService.get(files[i]);

      // 拡張子の確認
      const pos = fileName.lastIndexOf(".");

      if (pos === -1) {
        console.log("拡張子のないファイルがありました: %s", files[i]);

        return "";
      }

      // ext = 拡張子
      const ext = fileName.slice(pos + 1);

      // 拡張子が pdf の場合は新規タブで開くように target 属性となる配列に _blank を追加する
      // pdf 以外は target 属性となる配列に空文字で追加する
      if (ext === "pdf") {
        blankOrDirectList.push("_blank");
      } else {
        blankOrDirectList.push("");
      }

      fileURLList.push(fileUrl);
    }

    return fileProperties;
  }
}

const fileService = ServiceFactory.create("file");
